




























import Vue, { PropOptions } from 'vue';
import SideBarItem from './SideBarItem.vue';

export interface ISideMenuItem {
  itemID?: number;
  groupingID: number;
  parentID?: number;
  name: string;
}

export default Vue.extend({
  name: 'SideMenuBase',
  components: {
    SideBarItem,
  },
  props: {
    list: Array as PropOptions<ISideMenuItem[]>,
    setItemID: Number,
  },
  watch: {
    setItemID: {
      immediate: true,
      handler(v) {
        this.selectedID = v;
      },
    },
    list: {
      immediate: true,
      handler() {
        const parentList = this.list.filter((v2) => !v2.itemID);
        this.parentList = parentList;

        const childList = this.list.filter((v2) => v2.itemID);
        this.childList = childList;
      },
    },
  },
  data() {
    return {
      selectedID: 0,
      parentList: [] as ISideMenuItem[],
      childList: [] as ISideMenuItem[],
    };
  },
  methods: {
    getParentID(v: ISideMenuItem) {
      return v.groupingID;
    },
    getChildID(v: ISideMenuItem) {
      return v.itemID;
    },
    getItemText(v: ISideMenuItem) {
      return v.name;
    },
    clickItem(v: ISideMenuItem) {
      this.selectedID = v.itemID || 0;
      this.$emit('clickItem', v);
    },
  },
});
